import Vue from 'vue'
import Router from 'vue-router'
import Booking from './views/Booking.vue'
import {
  db,
  auth
} from '@/fb'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'booking',
      component: Booking,
      meta: {
        requiresGuest: true
      }
    }
  ]
});

//Nav Guards
router.beforeEach((to, from, next) => {
  //check for requird auth guard
  const record = to.matched.find(record => record.meta.cookies && !hasCookies(record.meta.requiresAuth));
  const guest = to.matched.find(record => record.meta.cookies && !hasCookies(record.meta.requiresGuest));
  if (auth.currentUser) {
    if (record) {
      next({
        path: record.meta.redirect || '/'
      });
    } else {
      next();
    }
  } else {
    if (guest) {
      next({
        path: record.meta.redirect || '/'
      });
    } else {
      next();
    }
  }

});
export default router;